import script from "./AssessmentGovernanceStructure.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentGovernanceStructure.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentGovernanceStructure.vue?vue&type=style&index=0&id=8b0a6750&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b0a6750"]])

export default __exports__